import type { Company } from '@/types/directory/Company';

import { getLocalizedText } from '@/utils/localization';

/** Job title of one employee, keyed by the `jobTitleId` the report carries. */
export type JobTitleLabels = Record<string, string>;

/**
 * Resolves the company's job titles into the localized labels the employee table shows under each
 * name. The report DTO only carries `jobTitleId`; the company information the filter bar already
 * loads carries the labels, so no extra round-trip is needed. An employee whose id resolves to
 * nothing simply shows no job title.
 */
export const buildJobTitleLabels = (company: Company | undefined): JobTitleLabels =>
    Object.fromEntries(
        (company?.jobTitles ?? []).map((jobTitle) => [
            jobTitle.id,
            getLocalizedText(jobTitle.names),
        ]),
    );
